import { Invoice, InvoiceBuildType } from './invoicing';
import { InvoiceProcessingRequest, InvoiceViewRequest } from './invoicing.request';
import { FinancialDocumentAllocateRequest } from './financial.document.allocation';
import { FinancialDocumentCardIntentRequest, FinancialDocumentCardPaymentRecordRequest, FinancialDocumentPaymentPrepareRequest, FinancialDocumentPaymentRecordRequest } from './financial.document.payment';

export interface InvoiceBuildDraftRequest {
    type: InvoiceBuildType;
    jobId: string;
    stageId?: string;
}

export interface InvoiceBuildCreditNoteRequest {
    sourceInvoiceId: string;
    isLinkedJob: boolean;
}

export interface InvoiceCreateRequest {
    invoice: Invoice;
}

export interface InvoiceEditRequest {
    invoice: Invoice;
}

export interface InvoiceSyncRequest {
    invoiceId: string;
}

export interface InvoiceGetByIdRequest {
    invoiceId: string;
}

export interface InvoiceGetByEntityRequest {
    entityId: string;
}

export enum InvoiceCommandId {
  BuildDraft = 'BuildDraft',
  BuildCreditNote = 'BuildCreditNote',
  CreateAndSend = 'CreateAndSend',
  Edit = 'Edit',
  Processing = 'Processing',
  UpdateAndRecalculate = 'UpdateAndRecalculate',
  Sync = 'Sync',
  PrepaymentCreate = 'PrepaymentCreate',
  GetDetails = 'GetDetails',
  GetEmailConfig = 'GetEmailConfig',
  GetView = 'GetView',
  GetByEntity = 'GetByEntity',
  Approve = 'approve',
  ApproveAndSend = 'approveAndSend',
  Void = 'void',
  Retry = 'retry',
  Reissue = 'reissue',
  PreparePayment = 'preparePayment',
  RecordPayment = 'recordPayment',
  CardPaymentIntent = 'cardPaymentIntent',
  RecordCardPayment = 'recordCardPayment',
  PrepareAllocation = 'prepareAllocation',
  AllocateCredit = 'allocateCredit',
}

export type InvoiceNamedLifecycleRequest = { invoiceId: string };

export type InvoiceCommandRequest =
    | { commandId: InvoiceCommandId.BuildDraft; data: InvoiceBuildDraftRequest }
    | { commandId: InvoiceCommandId.BuildCreditNote; data: InvoiceBuildCreditNoteRequest }
    | { commandId: InvoiceCommandId.CreateAndSend; data: InvoiceCreateRequest }
    | { commandId: InvoiceCommandId.Edit; data: InvoiceEditRequest }
    | { commandId: InvoiceCommandId.Processing; data: InvoiceProcessingRequest }
    | { commandId: InvoiceCommandId.Approve; data: InvoiceNamedLifecycleRequest }
    | { commandId: InvoiceCommandId.ApproveAndSend; data: InvoiceNamedLifecycleRequest }
    | { commandId: InvoiceCommandId.Void; data: InvoiceNamedLifecycleRequest }
    | { commandId: InvoiceCommandId.Retry; data: InvoiceNamedLifecycleRequest }
    | { commandId: InvoiceCommandId.Reissue; data: InvoiceNamedLifecycleRequest }
    | { commandId: InvoiceCommandId.UpdateAndRecalculate; data: InvoiceProcessingRequest }
    | { commandId: InvoiceCommandId.Sync; data: InvoiceSyncRequest }
    | { commandId: InvoiceCommandId.PrepaymentCreate; data: InvoiceCreateRequest }
    | { commandId: InvoiceCommandId.GetDetails; data: InvoiceGetByIdRequest }
    | { commandId: InvoiceCommandId.GetEmailConfig; data: InvoiceGetByIdRequest }
    | { commandId: InvoiceCommandId.GetView; data: InvoiceViewRequest }
    | { commandId: InvoiceCommandId.GetByEntity; data: InvoiceGetByEntityRequest }
    | { commandId: InvoiceCommandId.PreparePayment; data: FinancialDocumentPaymentPrepareRequest }
    | { commandId: InvoiceCommandId.RecordPayment; data: FinancialDocumentPaymentRecordRequest }
    | { commandId: InvoiceCommandId.CardPaymentIntent; data: FinancialDocumentCardIntentRequest }
    | { commandId: InvoiceCommandId.RecordCardPayment; data: FinancialDocumentCardPaymentRecordRequest }
    | { commandId: InvoiceCommandId.PrepareAllocation; data: FinancialDocumentPaymentPrepareRequest }
    | { commandId: InvoiceCommandId.AllocateCredit; data: FinancialDocumentAllocateRequest };
